import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c(_vm.onlyVisual ? 'div' : 'button', {
    tag: "component",
    class: [_vm.$style.ClickableIcon, _defineProperty({}, _vm.$style.active, _vm.active)],
    attrs: {
      "data-badge": _vm.badgeNumber || undefined
    }
  }, [_c(_setup.SIcon, {
    attrs: {
      "icon": _vm.icon,
      "size": "20",
      "alt": ""
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };